
import Vue from "vue";
import TodoForm from "@/components/AddTaskFrom.vue"; // @ is an alias to /src
import store from "@/store"; // store type is HelloStore
import UIkit from "uikit";

export default Vue.extend({
  components: {
    TodoForm,
  },
  data() {
    return {
      todo: {
        name: {
          type: String,
        },
        category: {
          type: String,
        },
      },
      errorMsg: " ",
      modalOpen: false,
      successfulMsg: "You todo has been added",
    };
  },
  methods: {
    inputData(data: any) {
      this.todo = data;
    },
    addNewTask() {
      if (
        !this.todo.name ||
        !this.todo.category ||
        typeof this.todo.name !== "string" ||
        typeof this.todo.category !== "string"
      ) {
        this.errorMsg = "All the field are required";
        return;
      }
      const taskId = Math.random() * 100; // task id
      store.dispatch("add_new_todo", { ...this.todo, id: taskId });
      this.errorMsg = "";
      this.modalOpen = false;
      UIkit.notification({
        message: this.successfulMsg,
        pos: "bottom-left",
        status: "success",
      });
    },
  },
});
